










































import Vue from 'vue'
import Component from 'vue-class-component'
import GridFilter from '@/components/grids/companyList/filter/GridFilter.vue'
import GridFooter from '@/components/grids/main/gridFooter/GridFooter.vue'
import GridComponent from '@/components/grids/companyList/list/GridComponent.vue'
import ActionButton from '@/components/lib/button/ActionButton.vue'
import FormInput from '@/components/lib/input/FormInput.vue'
import { StoreActionTypes } from '@/store/types'
import ModalComponent from '@/components/modal/ModalComponent.vue'

@Component({
  components: {
    GridFilter,
    GridFooter,
    GridComponent,
    ActionButton,
    FormInput,
    ModalComponent
  }
})
export default class Companies extends Vue {
    private componentClass = "CompaniesList"

    private modalShow = false
    private companyName = ''

    handleCreateNewCompanyBtnClick() {
        this.modalShow = !this.modalShow
    }

    async handleModalOkBtnClick() {
        await this.createCompany()
    }

    async createCompany() {
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_COMPANY_CREATE, this.companyName)
        const companyId = this.$store.getters.getCompaniesSelectedCompany.id
        this.handleCreateNewCompanyBtnClick()
        this.$router.push(`companies/${companyId}`)
    }

    companyNameChange(text: string) {
        this.companyName = text
    } 

    get modalOkBtnDisabled() {
        return this.disabled
    }

    get disabled (){
        return this.$store.getters.isCompaniesDataLoading
    }

    listener() {
        console.log('onEnter')
    }

    get getTotal(): number {
        return this.$store.getters.getCompaniesTotal
    }

    get getCurrentPage(): number {
        return this.$store.getters.getCompaniesListPage
    }

    get perPage(): number {
        return this.$store.getters.getCompaniesListPerPage
    }

    async handlePageItemQuantitySelectChangeEvent(selected: string) {
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST_PER_PAGE, parseInt(selected))
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST)
    }

    async handlePaginatorChangeEvent(page: number) {
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST_PAGE, page)
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST)
    }
}
